/* SABY theme — Shopify AJAX cart drawer, quick-add, swatches, reveals */
(function () {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const money = (cents) => {
    const amount = (cents / 100);
    const s = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    return (window.Shopify && Shopify.currency && Shopify.currency.active === "USD" ? "$" : "") + s + (window.Shopify && Shopify.currency && Shopify.currency.active !== "USD" ? " " + Shopify.currency.active : "");
  };

  /* ---------- nav ---------- */
  const nav = document.getElementById("nav");
  if (nav && document.body.classList.contains("home-body")) {
    const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  const burger = document.getElementById("burger");
  const menu = document.getElementById("mobileMenu");
  if (burger && menu && !document.body.classList.contains("home-body")) {
    burger.addEventListener("click", () => {
      const open = !menu.classList.contains("is-open");
      menu.classList.toggle("is-open", open);
      burger.setAttribute("aria-expanded", String(open));
      menu.setAttribute("aria-hidden", String(!open));
    });
  }

  /* ---------- cart drawer ---------- */
  const drawer = document.querySelector(".cartdrawer");
  const overlay = document.querySelector(".bagoverlay");
  const upsellWrap = document.querySelector("[data-cart-upsell]");
  const FREE_SHIP = upsellWrap ? (parseInt(upsellWrap.dataset.freeShip, 10) || 0) * 100 : 0;

  const openDrawer = () => { if (!drawer) return; drawer.classList.add("is-open"); overlay.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove("is-open"); overlay.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); };
  document.querySelectorAll("[data-cart-close]").forEach((el) => el.addEventListener("click", closeDrawer));
  document.querySelectorAll("[data-cart-open]").forEach((el) => el.addEventListener("click", (e) => { e.preventDefault(); refresh().then(openDrawer); }));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  const render = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count ? "" : "none"; });
    const dc = document.querySelector("[data-cart-drawer-count]");
    if (dc) dc.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    const items = document.querySelector("[data-cart-items]");
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = '<p class="cartdrawer__empty">Your cart is empty — your brows have opinions about that.</p>';
    } else {
      items.innerHTML = cart.items.map((it) => `
        <div class="cartitem">
          <a href="${it.url}" class="cartitem__img"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_200x$1$2") : ""}" alt=""></a>
          <div class="cartitem__info">
            <b>${it.product_title}${it.variant_title && it.variant_title !== "Default Title" ? " — " + it.variant_title : ""}</b>
            <span>${money(it.final_price)}</span>
            <div class="qty qty--sm">
              <button type="button" data-line-dec="${it.key}" aria-label="Decrease">&minus;</button>
              <output>${it.quantity}</output>
              <button type="button" data-line-inc="${it.key}" aria-label="Increase">+</button>
            </div>
          </div>
          <button class="cartitem__rm" data-line-rm="${it.key}" aria-label="Remove">&times;</button>
        </div>`).join("");
    }
    const totalEl = document.querySelector("[data-cart-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
    const ship = document.querySelector("[data-cart-ship]");
    const bar = document.querySelector("[data-cart-shipbar]");
    if (ship && bar && FREE_SHIP > 0) {
      if (!cart.item_count) { ship.innerHTML = ""; bar.style.width = "0%"; }
      else if (cart.total_price >= FREE_SHIP) { ship.innerHTML = "<b>Free shipping unlocked ✓</b>"; ship.classList.add("is-free"); bar.style.width = "100%"; bar.classList.add("is-free"); }
      else { ship.innerHTML = "Add <b>" + money(FREE_SHIP - cart.total_price) + "</b> more for free shipping"; ship.classList.remove("is-free"); bar.classList.remove("is-free"); bar.style.width = Math.min(100, (cart.total_price / FREE_SHIP) * 100) + "%"; }
    }
    const co = document.querySelector("[data-cart-checkout]");
    if (co) { co.style.opacity = cart.item_count ? 1 : 0.4; co.style.pointerEvents = cart.item_count ? "auto" : "none"; }
    items.querySelectorAll("[data-line-inc]").forEach((b) => b.addEventListener("click", () => changeLine(b.dataset.lineInc, +1)));
    items.querySelectorAll("[data-line-dec]").forEach((b) => b.addEventListener("click", () => changeLine(b.dataset.lineDec, -1)));
    items.querySelectorAll("[data-line-rm]").forEach((b) => b.addEventListener("click", () => setLine(b.dataset.lineRm, 0)));
  };

  const renderUpsell = (cart) => {
    if (!upsellWrap) return;
    const handle = upsellWrap.dataset.upsellCollection;
    if (!handle) { upsellWrap.innerHTML = ""; return; }
    fetch("/collections/" + handle + "/products.json?limit=6")
      .then((r) => r.json())
      .then((data) => {
        const inCart = cart.items.map((i) => i.product_id);
        const candidates = (data.products || []).filter((p) => !inCart.includes(p.id)).slice(0, 3);
        if (!cart.item_count || !candidates.length) { upsellWrap.innerHTML = ""; return; }
        upsellWrap.innerHTML = '<p class="upsell__label">Complete the ritual</p>' + candidates.map((p) => {
          const v = p.variants && p.variants[0];
          const img = p.images && p.images[0] ? p.images[0].src : "";
          return `<div class="upitem">
            <img src="${img}" alt="">
            <div><b>${p.title}</b><span>${v ? money(Math.round(parseFloat(v.price) * 100)) : ""}</span></div>
            <button class="btn btn--sm" data-upsell-variant="${v ? v.id : ""}">Add</button>
          </div>`;
        }).join("");
        upsellWrap.querySelectorAll("[data-upsell-variant]").forEach((b) => b.addEventListener("click", () => addVariant(b.dataset.upsellVariant, 1)));
      })
      .catch(() => { upsellWrap.innerHTML = ""; });
  };

  const refresh = () => fetch("/cart.js").then((r) => r.json()).then((c) => { render(c); renderUpsell(c); return c; });
  const setLine = (key, qty) =>
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then((r) => r.json()).then((c) => { render(c); renderUpsell(c); });
  const changeLine = (key, delta) =>
    fetch("/cart.js").then((r) => r.json()).then((c) => {
      const it = c.items.find((i) => i.key === key);
      if (it) setLine(key, Math.max(0, it.quantity + delta));
    });
  const addVariant = (id, qty) =>
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 }) })
      .then(() => refresh()).then(openDrawer);

  /* quick-add buttons everywhere */
  document.querySelectorAll("[data-quick-add]").forEach((b) => {
    b.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); addVariant(b.dataset.quickAdd, 1); });
  });

  /* ---------- PDP: gallery thumbs ---------- */
  const mainImg = document.querySelector("[data-main-img]");
  document.querySelectorAll("[data-thumb]").forEach((t) => {
    t.addEventListener("click", () => {
      if (!mainImg) return;
      mainImg.src = t.dataset.thumb;
      document.querySelectorAll("[data-thumb]").forEach((x) => x.classList.remove("is-active"));
      t.classList.add("is-active");
    });
  });

  /* ---------- PDP: shade swatches ---------- */
  const swatches = document.querySelectorAll("[data-swatch]");
  if (swatches.length) {
    const idInput = document.querySelector("[data-variant-id]");
    const priceEl = document.querySelector("[data-price]");
    const nameEl = document.querySelector("[data-shade-name]");
    swatches.forEach((b) => {
      b.addEventListener("click", () => {
        swatches.forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        if (idInput) idInput.value = b.dataset.variantId;
        if (priceEl && b.dataset.variantPrice) priceEl.textContent = b.dataset.variantPrice;
        if (nameEl) nameEl.textContent = b.dataset.variantTitle;
        if (mainImg && b.dataset.variantImg) mainImg.src = b.dataset.variantImg;
      });
    });
  }

  /* ---------- PDP: qty + AJAX add ---------- */
  const qty = document.querySelector("[data-qty]");
  if (qty) {
    const out = qty.querySelector("output");
    const hidden = qty.querySelector("[data-qty-input]");
    const btns = qty.querySelectorAll("button");
    let v = 1;
    const set = (n) => { v = Math.min(9, Math.max(1, n)); out.textContent = v; if (hidden) hidden.value = v; };
    btns[0].addEventListener("click", () => set(v - 1));
    btns[btns.length - 1].addEventListener("click", () => set(v + 1));
  }
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: fd })
        .then((r) => r.json())
        .then(() => refresh())
        .then(openDrawer)
        .catch(() => form.submit());
    });
  }

  refresh();

  /* ---------- reveals on non-home pages ---------- */
  if (document.body.classList.contains("home-body")) return;
  const show = (el) => { el.style.opacity = 1; el.style.transform = "none"; };
  if (reduced || !window.gsap || !window.ScrollTrigger) {
    document.querySelectorAll(".reveal").forEach(show);
    return;
  }
  gsap.registerPlugin(ScrollTrigger);
  if (window.Lenis) {
    const lenis = new Lenis({ lerp: 0.085 });
    lenis.on("scroll", () => ScrollTrigger.update());
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  gsap.from(".pdp__gallery", { x: -44, opacity: 0, duration: 1.1, ease: "expo.out", delay: 0.1 });
  gsap.from(".pdp__info > *", { y: 30, opacity: 0, stagger: 0.06, duration: 0.9, ease: "expo.out", delay: 0.2 });
  document.querySelectorAll(".reveal").forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.top < innerHeight * 0.92) { show(el); return; }
    gsap.to(el, { opacity: 1, y: 0, duration: 1, ease: "expo.out", scrollTrigger: { trigger: el, start: "top 88%", once: true } });
  });
})();
